import {
  getAllowedUserAdminRoleAssignments,
  getCanAccessThreadExtendedActivity,
  getCanAssignUserAdminRoles,
  getCanDesignateLeaders,
  getCanRemoveAnswersTopics,
  getCanShowMobileCrossSell,
  getEditNetworkQuestionsSettingsStatus,
  getFeatureAccessSettings,
  getFeatureAccessSettingsStatus,
  getIsGroupQuestionsAIImporterEnabled,
  getIsNetworkQuestionsAIFeaturesEnabled,
  getIsNetworkQuestionsAIImporterEnabled,
  getIsPrivateContentModeActiveForViewer,
  getNetworkQuestionsEnablementMode,
  getViewerCanAccessM365Copilot,
  getViewerCanAccessNetworkLevelInsights,
  getViewerCanAccessNetworkQuestions,
  getViewerCanCreateMultiLanguageMessage,
  getViewerCanHideThreadsForNetworkInDiscovery,
  isDraftPostsEnabled,
} from '@ms/yammer-data/dist/domains/featureAccessSettings/selectors';
import type { NetworkQuestionsEnablementMode } from '@ms/yammer-graphql';
import { isTeamsBrandedExperience } from '@ms/yammer-web-support/dist/teamsBrandedExp/isTeamsBrandedExperience';

import { useSelector } from '../useSelector';

type UseFeatureAccessSettings = () => ReturnType<typeof getFeatureAccessSettings>;
/**
 * @deprecated PERFORMANCE This returns the ENTIRE FeatureAccessSettings object which will force re-renders if any
 * settings change due to any related API call. Use more specific selectors instead.
 */
export const useFeatureAccessSettings: UseFeatureAccessSettings = () => useSelector(getFeatureAccessSettings);

type UseFeatureAccessSettingsStatus = () => ReturnType<typeof getFeatureAccessSettingsStatus>;
export const useFeatureAccessSettingsStatus: UseFeatureAccessSettingsStatus = () =>
  useSelector(getFeatureAccessSettingsStatus);

type UseNetworkQuestionsEnablementMode = () => NetworkQuestionsEnablementMode | undefined;
export const useNetworkQuestionsEnablementMode: UseNetworkQuestionsEnablementMode = () =>
  useSelector(getNetworkQuestionsEnablementMode);

type UseViewerCanAccessNetworkQuestions = () => ReturnType<typeof getViewerCanAccessNetworkQuestions>;
export const useViewerCanAccessNetworkQuestions: UseViewerCanAccessNetworkQuestions = () =>
  useSelector(getViewerCanAccessNetworkQuestions);

type UseViewerCanAccessNetworkLevelInsights = () => ReturnType<typeof getViewerCanAccessNetworkLevelInsights>;
export const useViewerCanAccessNetworkLevelInsights: UseViewerCanAccessNetworkLevelInsights = () =>
  useSelector(getViewerCanAccessNetworkLevelInsights);

type UseIsGroupQuestionsAIImporterEnabled = () => boolean | undefined;
export const useIsGroupQuestionsAIImporterEnabled: UseIsGroupQuestionsAIImporterEnabled = () =>
  useSelector(getIsGroupQuestionsAIImporterEnabled);

type UseIsNetworkQuestionsAIFeaturesEnabled = () => boolean | undefined;
export const useIsNetworkQuestionsAIFeaturesEnabled: UseIsNetworkQuestionsAIFeaturesEnabled = () =>
  useSelector(getIsNetworkQuestionsAIFeaturesEnabled);

type UseIsNetworkQuestionsAIImporterEnabled = () => boolean | undefined;
export const useIsNetworkQuestionsAIImporterEnabled: UseIsNetworkQuestionsAIImporterEnabled = () =>
  useSelector(getIsNetworkQuestionsAIImporterEnabled);

type UseEditNetworkQuestionsSettingsStatus = () => ReturnType<typeof getEditNetworkQuestionsSettingsStatus>;
export const useEditNetworkQuestionsSettingsStatus: UseEditNetworkQuestionsSettingsStatus = () =>
  useSelector(getEditNetworkQuestionsSettingsStatus);

type UseCanRemoveAnswersTopics = () => ReturnType<typeof getCanRemoveAnswersTopics>;
export const useCanRemoveAnswersTopics: UseCanRemoveAnswersTopics = () => useSelector(getCanRemoveAnswersTopics);

type UseCanAssignUserAdminRoles = () => ReturnType<typeof getCanAssignUserAdminRoles>;
export const useCanAssignUserAdminRoles: UseCanAssignUserAdminRoles = () => useSelector(getCanAssignUserAdminRoles);

type UseAllowedUserAdminRoleAssignments = () => ReturnType<typeof getAllowedUserAdminRoleAssignments>;
export const useAllowedUserAdminRoleAssignments: UseAllowedUserAdminRoleAssignments = () =>
  useSelector(getAllowedUserAdminRoleAssignments);

type UseCanDesignateLeaders = () => ReturnType<typeof getCanDesignateLeaders>;
export const useCanDesignateLeaders: UseCanDesignateLeaders = () => useSelector(getCanDesignateLeaders);

type UseCanAccessThreadExtendedActivity = () => ReturnType<typeof getCanAccessThreadExtendedActivity>;
export const useCanAccessThreadExtendedActivity: UseCanAccessThreadExtendedActivity = () =>
  useSelector(getCanAccessThreadExtendedActivity);

type UseCanShowMobileCrossSell = () => ReturnType<typeof getCanShowMobileCrossSell>;
export const useCanShowMobileCrossSell: UseCanShowMobileCrossSell = () => useSelector(getCanShowMobileCrossSell);

type UsegetViewerCanHideThreadsForNetworkInDiscovery = () => ReturnType<
  typeof getViewerCanHideThreadsForNetworkInDiscovery
>;
export const useGetViewerCanHideThreadsForNetworkInDiscovery: UsegetViewerCanHideThreadsForNetworkInDiscovery = () =>
  useSelector(getViewerCanHideThreadsForNetworkInDiscovery);

type UseIsPrivateContentModeActiveForViewer = () => boolean;
export const useIsPrivateContentModeActiveForViewer: UseIsPrivateContentModeActiveForViewer = () => {
  const isPrivateContentModeActiveForViewer = useSelector(getIsPrivateContentModeActiveForViewer);

  return !isTeamsBrandedExperience() && isPrivateContentModeActiveForViewer;
};

type UseIsDraftPostsEnabled = () => boolean;
export const useIsDraftPostsEnabled: UseIsDraftPostsEnabled = () => useSelector(isDraftPostsEnabled);

type UseCanViewerCreateMultiLanguageMessage = () => boolean;
export const useViewerCanCreateMultiLanguageMessage: UseCanViewerCreateMultiLanguageMessage = () =>
  useSelector(getViewerCanCreateMultiLanguageMessage);

type UseViewerCanAccessM365Copilot = () => boolean;
export const useViewerCanAccessM365Copilot: UseViewerCanAccessM365Copilot = () =>
  useSelector(getViewerCanAccessM365Copilot);
